import { gql } from "@apollo/client";


export const GET_Symposium_Photos_QUERY = gql`
query GetAppImages($status: AppImageStatus) {
  getAppImages(status: $status) {
    created_at
    filename
    folder
    id
    mime_type
    s3_key
    status
    updated_at
    url
  }
}
`
export const GET_Events_Photos_QUERY = gql`
query GetEvents($arcimedesRowId: ID) {
  getEvents(arcimedes_row_id: $arcimedesRowId) {
    arcimedes_row_id
    title
    description
    text
    date
    videoLinks {
      url
    }
    photos {
      id
      filename
      url
      s3_key
      status
    }
    showWebsite
    deleted
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`